/**
 * Kogui
 * Kogui App
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

import { ApiError } from '../model/apiError';
import { EstadoActividad } from '../model/estadoActividad';
import { KoguiActividad } from '../model/koguiActividad';
import { ProgramacionActividad } from '../model/programacionActividad';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable({
  providedIn: 'root'
})
export class KoguiActividadesService {

    protected basePath = 'https://virtserver.swaggerhub.com/yohanyflores/kogui/1.0.0';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }



    /**
     * La lista de actividades para un usuario en especifico.
     * Las Actividades.
     * @param actividadId El id de una actividad asociado a la empresa.
     * @param xFcmtoken 
     * @param $fields 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getKoguiActividadById(actividadId: string, xFcmtoken?: string, $fields?: string, observe?: 'body', reportProgress?: boolean): Observable<KoguiActividad>;
    public getKoguiActividadById(actividadId: string, xFcmtoken?: string, $fields?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<KoguiActividad>>;
    public getKoguiActividadById(actividadId: string, xFcmtoken?: string, $fields?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<KoguiActividad>>;
    public getKoguiActividadById(actividadId: string, xFcmtoken?: string, $fields?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (actividadId === null || actividadId === undefined) {
            throw new Error('Required parameter actividadId was null or undefined when calling getKoguiActividadById.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if ($fields !== undefined && $fields !== null) {
            queryParameters = queryParameters.set('$fields', <any>$fields);
        }

        let headers = this.defaultHeaders;
        if (xFcmtoken !== undefined && xFcmtoken !== null) {
            headers = headers.set('x-fcmtoken', String(xFcmtoken));
        }

        // authentication (implicit) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.get<KoguiActividad>(`${this.configuration.basePath}/kogui/actividades/${encodeURIComponent(String(actividadId))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * La lista de programaciones para una actividad especifica.
     * Las Actividades.
     * @param actividadId El id de una actividad asociado a la empresa.
     * @param xFcmtoken 
     * @param $fields 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getKoguiActividadByIdProgamaciones(actividadId: string, xFcmtoken?: string, $fields?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ProgramacionActividad>>;
    public getKoguiActividadByIdProgamaciones(actividadId: string, xFcmtoken?: string, $fields?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ProgramacionActividad>>>;
    public getKoguiActividadByIdProgamaciones(actividadId: string, xFcmtoken?: string, $fields?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ProgramacionActividad>>>;
    public getKoguiActividadByIdProgamaciones(actividadId: string, xFcmtoken?: string, $fields?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (actividadId === null || actividadId === undefined) {
            throw new Error('Required parameter actividadId was null or undefined when calling getKoguiActividadByIdProgamaciones.');
        }

        let queryParameters = new HttpParams({encoder: this.encoder});
        if ($fields !== undefined && $fields !== null) {
            queryParameters = queryParameters.set('$fields', <any>$fields);
        }

        let headers = this.defaultHeaders;
        if (xFcmtoken !== undefined && xFcmtoken !== null) {
            headers = headers.set('x-fcmtoken', String(xFcmtoken));
        }

        // authentication (implicit) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.get<Array<ProgramacionActividad>>(`${this.configuration.basePath}/kogui/actividades/${encodeURIComponent(String(actividadId))}/programaciones/`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Obtiene una foto de actividad identificada por id.
     * Obtiene una foto de actividad del id dado.
     * @param fotoId El id de la foto.
     * @param xFcmtoken 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getKoguiActividadeFotosById(fotoId: string, xFcmtoken?: string, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public getKoguiActividadeFotosById(fotoId: string, xFcmtoken?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public getKoguiActividadeFotosById(fotoId: string, xFcmtoken?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public getKoguiActividadeFotosById(fotoId: string, xFcmtoken?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (fotoId === null || fotoId === undefined) {
            throw new Error('Required parameter fotoId was null or undefined when calling getKoguiActividadeFotosById.');
        }

        let headers = this.defaultHeaders;
        if (xFcmtoken !== undefined && xFcmtoken !== null) {
            headers = headers.set('x-fcmtoken', String(xFcmtoken));
        }

        // authentication (implicit) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'image/_*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.get(`${this.configuration.basePath}/kogui/actividades/fotos/${encodeURIComponent(String(fotoId))}`,
            {
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Obtiene la lista de actividades paginadas. por defecto se ordenan en orden descendiente de creacion.
     * Al obtener las actividadesd puede especificar una paginacion y orden para mostrarlo.
     * @param xFcmtoken 
     * @param $filter 
     * @param $size 
     * @param $page 
     * @param $sort 
     * @param $fields 
     * @param $search Permite buscar por fulltext.
     * @param estado Especifica el estado a buscar.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getKoguiActividades(xFcmtoken?: string, $filter?: string, $size?: number, $page?: number, $sort?: string, $fields?: string, $search?: string, estado?: EstadoActividad, observe?: 'body', reportProgress?: boolean): Observable<Array<KoguiActividad>>;
    public getKoguiActividades(xFcmtoken?: string, $filter?: string, $size?: number, $page?: number, $sort?: string, $fields?: string, $search?: string, estado?: EstadoActividad, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<KoguiActividad>>>;
    public getKoguiActividades(xFcmtoken?: string, $filter?: string, $size?: number, $page?: number, $sort?: string, $fields?: string, $search?: string, estado?: EstadoActividad, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<KoguiActividad>>>;
    public getKoguiActividades(xFcmtoken?: string, $filter?: string, $size?: number, $page?: number, $sort?: string, $fields?: string, $search?: string, estado?: EstadoActividad, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let queryParameters = new HttpParams({encoder: this.encoder});
        if ($filter !== undefined && $filter !== null) {
            queryParameters = queryParameters.set('$filter', <any>$filter);
        }
        if ($size !== undefined && $size !== null) {
            queryParameters = queryParameters.set('$size', <any>$size);
        }
        if ($page !== undefined && $page !== null) {
            queryParameters = queryParameters.set('$page', <any>$page);
        }
        if ($sort !== undefined && $sort !== null) {
            queryParameters = queryParameters.set('$sort', <any>$sort);
        }
        if ($fields !== undefined && $fields !== null) {
            queryParameters = queryParameters.set('$fields', <any>$fields);
        }
        if ($search !== undefined && $search !== null) {
            queryParameters = queryParameters.set('$search', <any>$search);
        }
        if (estado !== undefined && estado !== null) {
            queryParameters = queryParameters.set('estado', <any>estado);
        }

        let headers = this.defaultHeaders;
        if (xFcmtoken !== undefined && xFcmtoken !== null) {
            headers = headers.set('x-fcmtoken', String(xFcmtoken));
        }

        // authentication (implicit) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.get<Array<KoguiActividad>>(`${this.configuration.basePath}/kogui/actividades/`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
